import { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom/cjs/react-router-dom';
import {
  enviarOrden,
  getImprimirOrden,
  getReimprimirOrden,
  validarReimpresionOrden,
  validarReimpresionOrdenById,
} from '../../services/Seo/Orden';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  FormControl,
  Grid,
  Skeleton,
  TextField,
  Typography,
} from '@mui/material';
import ButtonBack from '../Breadcrumb/ButtonBack';
import { CheckCircle, HighlightOff } from '@mui/icons-material';
import DetalleCoberturaOrdenData from './components/DetalleCoberturaOrdenData';
import QrPreview from '../Common/QrPreview';
import { useOrdenAutomaticaPreview } from './hooks/useOrdenAutomaticaPreview';

export const OrdenAutomaticaPreview = () => {
  const { idOrden } = useParams();

  const {
    datosOrden,
    enviarCorreo,
    getOrdenData,
    loading,
    setDatosOrden,
    successCorreo,
    urlReporte,
  } = useOrdenAutomaticaPreview();

  useEffect(() => {
    setDatosOrden(null); // Limpiar datos anteriores
    if (idOrden) {
      getOrdenData(idOrden);
    }
  }, [idOrden, getOrdenData]);

  return (
    <Grid container spacing={2}>
      <ButtonBack />

      <Grid item xs={12}>
        <Card sx={{ paddingX: { xs: 0, sm: 1 } }}>
          <CardContent>
            <Grid
              container
              direction='row'
              justifyContent='flex-start'
              alignItems='felx-end'
              spacing={1}
            >
              <Grid item>
                <Typography variant='h6'>Orden Generada</Typography>
              </Grid>
              <Grid item>
                <CheckCircle fontSize='small' color='primary' />
              </Grid>
            </Grid>

            <Grid container spacing={1} rowSpacing={1} gap={1}>
              <Grid item xs={12}>
                {datosOrden?.orden && !loading ? (
                  <>
                    <QrPreview
                      showDownload={true}
                      showPrint={true}
                      urlReporte={urlReporte}
                      showMail={true}
                      correo={datosOrden?.afiliado.correo}
                      loadingEnviar={loading}
                      successCorreo={successCorreo}
                      onEnviarCorreo={enviarCorreo}
                      nombreReporte={'Orden_oser_' + datosOrden?.orden.numeroOrden}
                      qrValue={JSON.stringify({
                        codigo: datosOrden?.orden.numeroOrdenFormatoCodigo,
                      })}
                    />
                  </>
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: '16px',
                      mb: 3,
                    }}
                  >
                    <Skeleton variant='rectangular' width='128px' height='128px' />
                    <Skeleton variant='rectangular' width='380px' height='32px' />
                    <Skeleton variant='rectangular' width='350px' height='64px' />
                  </Box>
                )}
                <FormControl fullWidth={true} variant='standard' margin='normal'>
                  {datosOrden?.orden ? (
                    <TextField
                      id='numero-orden'
                      variant='standard'
                      label='Nro. de Orden'
                      value={datosOrden?.orden.numeroOrden}
                      size='small'
                      fullWidth
                      InputProps={{
                        readOnly: true,
                        style: { fontWeight: 'bold' },
                      }}
                    />
                  ) : (
                    <Skeleton variant='rectangular' height='45px' />
                  )}
                </FormControl>
                <FormControl fullWidth={true} variant='standard' margin='normal'>
                  {datosOrden?.afiliado ? (
                    <TextField
                      id='afiliado'
                      label='Afiliado'
                      variant='standard'
                      defaultValue={`(${datosOrden?.afiliado.numerodocumentoformateado}) ${datosOrden?.afiliado.nombre}, ${datosOrden?.afiliado.apellido}`}
                      size='small'
                      fullWidth
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  ) : (
                    <Skeleton variant='rectangular' height='45px' />
                  )}
                </FormControl>
                <FormControl fullWidth={true} variant='standard' margin='normal'>
                  {datosOrden?.prestador ? (
                    <TextField
                      id='prestador'
                      label='Prestador'
                      variant='standard'
                      defaultValue={`(${datosOrden?.prestador.codigoPrestador}) ${
                        datosOrden?.prestador.razonSocial
                      } ${
                        datosOrden?.prestador?.especialidades
                          ? `(${datosOrden?.prestador?.especialidades
                              ?.map((espe) => espe.descripcion)
                              .join(', ')} ) `
                          : ''
                      } `}
                      size='small'
                      multiline
                      fullWidth
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  ) : (
                    <Skeleton variant='rectangular' height='45px' />
                  )}
                </FormControl>
                <FormControl fullWidth={true} variant='standard' margin='normal'>
                  {datosOrden?.arancelTotal ? (
                    <TextField
                      id='coseguro'
                      label='Coseguro a pagar al prestador'
                      variant='standard'
                      defaultValue={`$ ${datosOrden?.arancelTotal.totalNumero}`}
                      size='small'
                      fullWidth
                      InputProps={{
                        readOnly: true,
                        style: { fontWeight: 'bold' },
                      }}
                    />
                  ) : (
                    <Skeleton variant='rectangular' height='45px' />
                  )}
                </FormControl>
                {datosOrden?.practicas ? (
                  <DetalleCoberturaOrdenData detallePracticas={datosOrden?.practicas} />
                ) : (
                  <FormControl fullWidth={true} variant='standard' margin='normal'>
                    <Skeleton variant='rectangular' height='45px' />
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Box sx={{ marginLeft: 'auto', marginBottom: 2, marginRight: 2 }}>
              <Button
                component={Link}
                to='/'
                size='small'
                startIcon={<HighlightOff />}
                variant='contained'
                color='primary'
              >
                Cerrar
              </Button>
            </Box>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};
